<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-icon_container slds-icon-standard-groups"
                title="Project Allocation">
            <svg aria-hidden="true" class="slds-icon slds-page-header__icon">
              <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#groups"></use>
            </svg>
            <span class="slds-assistive-text" i18n>Project Allocation</span>
          </span>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span i18n id="pa-hdr">Project Allocation</span>
                <span class="slds-page-header__title" id="pa-name">{{projectName}}</span>
              </h1>
            </div>
            <div class="slds-page-header__name-switcher">
              <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
                <button (click)="onProjectSelectClick()"
                        aria-haspopup="true"
                        class="slds-button slds-button_icon slds-button_icon-small"
                        i18n-title
                        id="pa-project-select" title="Select Project">
                  <svg aria-hidden="true" class="slds-button__icon slds-icon_x-small">
                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
                  </svg>
                  <span class="slds-assistive-text" i18n>Select Project</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">

        <div class="slds-page-header__control slds-show_medium">
          <div class="slds-avatar slds-m-right_small">
            <img *ngIf="busy" alt="Loading ..." id="busy" src="/assets/images/busy.svg" title="Loading ...">
          </div>
          <div class="slds-m-right_small slds-show_inline-block">
            <acc-help-button title="Project Allocation" vimeoId="366642577" youtubeId="5yWOKTGFVbw">
              Allocate Resources to Project Lines
              <ul class="slds-list_dotted">
                <li>Assign an individual Resource to a Line/Deliverable - the person who does the work or is responsible for it.
                </li>
                <li>Allocate multiple Resources - persons who contribute.</li>
              </ul>
              <p class="help-p">If enabled, only Resources assigned/allocated to a project/line can select it for
                Time/Expenses:</p>
              <ul class="slds-list_dotted">
                <li>If a <strong>Resource</strong> has <em style="background: lightblue">Access to All</em> projects/lines
                  (indicated by light blue background), no explicit allocation is needed.
                </li>
                <li>If a <strong>Project Line</strong> is <em style="background: limegreen;">Share with All</em> (indicated by
                  lime background), no explicit allocation is needed.
                </li>
                <li>If a <strong>Project</strong> is <em style="background: lightgreen">Share All Lines</em> (indicated by light
                  green background), no explicit allocation is needed.
                </li>
              </ul>
              <p>You still want to assign individual Resources to Project Lines
                or explicitly allocate Resources for planning purposes.</p>
            </acc-help-button>
          </div>

          <button (click)="doRefresh()"
                  class="slds-button slds-button_icon slds-button_icon-border"
                  id="ps-refresh" title="Refresh">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"></use>
            </svg>
            <span class="slds-assistive-text" i18n>Refresh</span>
          </button>
          <button (click)="onReset()"
                  class="slds-button slds-button_neutral"
                  id="ps-reset">
            <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#undo"></use>
            </svg>
            <span i18n>Reset</span>
          </button>

          <button (click)="onSave()"
                  [disabled]="isSaveDisabled"
                  class="slds-button slds-button_neutral"
                  id="ps-save">
            <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#connected_apps"></use>
            </svg>
            <span i18n>Save</span>
          </button>

        </div>
      </div>
    </div>
  </div><!--header-row-->

  <!-- shareAll - status -->
  <div class="slds-page-header__row slds-page-header__row_gutters">
    <div [formGroup]="formGroupProject"
         class="slds-page-header__col-details">
      <ul class="slds-page-header__detail-row">
        <li class="slds-page-header__detail-block">

          <div class="slds-form-element">
            <div class="slds-form-element__control">
              <div class="slds-checkbox">
                <input formControlName="isShareAllLines"
                       id="project-share"
                       type="checkbox"/>
                <label class="slds-checkbox__label" for="project-share">
                  <span class="slds-checkbox_faux"></span>
                  <span class="slds-form-element__label">Share All Lines</span>
                </label>
              </div>
            </div>
          </div>
        </li>
        <li class="slds-page-header__detail-block">
          <acc-status-line [error]="error" [message]="message"></acc-status-line>
        </li>
      </ul>
      <ul class="slds-page-header__detail-row">
        <li class="slds-page-header__detail-blockX">
          <h3 class="slds-text-heading_small" i18n>Resource Restriction</h3>
          <psa-resource-search (resourceRestriction)="onResourceRestriction($event)"></psa-resource-search>
        </li>
      </ul>
    </div>
  </div>

</header>


<div class="slds-tabs_default slds-is-relative slds-m-vertical_medium">
  <!-- tabs -->
  <ul class="slds-tabs_default__nav" role="tablist">
    <li [class.slds-is-active]="isResourceTabActive"
        class="slds-tabs_default__item"
        role="presentation"
        title="Resource">
      <a (click)="onTabClick('Resource')"
         [attr.aria-selected]="isResourceTabActive ? 'true' : 'false'"
         [tabindex]="isResourceTabActive? 0 : -1"
         aria-controls="tab-resource"
         class="slds-tabs_default__link"
         id="tab-resource__item"
         role="tab">
        <span class="slds-tabs__left-icon">
          <span class="slds-icon_container slds-icon-standard-groups"
                title="Resource">
            <svg aria-hidden="true" class="slds-icon slds-icon_small">
              <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#user"></use>
            </svg>
          </span>
        </span>
        <span i18m>Resource</span>
      </a>
    </li>
    <li [class.slds-is-active]="!isResourceTabActive"
        class="slds-tabs_default__item"
        role="presentation"
        title="Allocation">
      <a (click)="onTabClick('Allocation')" [attr.aria-selected]="isResourceTabActive ? 'false' : 'true'"
         [tabindex]="isResourceTabActive ? -1 : 0"
         aria-controls="tab-allocation"
         class="slds-tabs_default__link"
         id="tab-allocation__item"
         role="tab">
        <span class="slds-tabs__left-icon">
          <span class="slds-icon_container slds-icon-standard-groups"
                title="Allocation">
            <svg aria-hidden="true" class="slds-icon slds-icon_small">
              <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#groups"></use>
            </svg>
          </span>
        </span>
        <span i18n>Allocation</span>
      </a>
    </li>
  </ul>

  <section [class.slds-hide]="!isResourceTabActive"
           [class.slds-show]="isResourceTabActive"
           aria-labelledby="tab-resource__item"
           class="slds-tabs_default__content"
           id="tab-resource"
           role="tabpanel">

    <!-- (1) projectLineAList \ resourceList-->
    <div *ngIf="showLinesByResource"
         class="slds-scrollable_x">
      <table class="slds-table slds-table_bordered"
             id="resource_line-resource">
        <caption class="slds-assistive-text" i18n>Resource assignment (project line)</caption>
        <thead>
        <tr class="slds-line-height_reset">
          <th scope="col">
            <div class="slds-truncate"
                 i18n title="Project Line">Project Line
            </div>
          </th>
          <ng-container *ngFor="let r of resourceList1; trackBy: trackByRecord; let ri = index">
            <th scope="col">
              <div [title]="r.label"
                   class="slds-truncate"
                   style="max-width: 12rem">{{r.label}}</div>
            </th>
          </ng-container>
        </tr>
        </thead>

        <tbody [formGroup]="formGroupResource" id="resource_line-resource_b">
        <tr *ngFor="let al of projectLineAList1; trackBy: trackByAllocation; let ai = index"
            class="slds-hint-parent">
          <th scope="row">
            <div class="slds-truncate" style="max-width: 12rem">{{al.projectLineName}}</div>
          </th>

          <ng-container *ngFor="let r of resourceList1; trackBy: trackByRecord; let ri = index">
            <td [attr.data-label]="r.name"
                class="alloc-cell">
              <input [formControlName]="al.projectLineId"
                     [id]="'r1_r' + ri + '_a' + ai"
                     [title]="al.projectLineName + ' - ' + r.name"
                     [value]="r.id"
                     type="radio"/>
            </td>
          </ng-container>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- (2) resourceList \ projectLineAList -->
    <div *ngIf="showResourceByLines"
         class="slds-scrollable_x">
      <table class="slds-table slds-table_bordered"
             id="resource_resource-line">
        <caption class="slds-assistive-text" i18n>Resource assignment (resource)</caption>
        <thead>
        <tr class="slds-line-height_reset">
          <th scope="col">
            <div class="slds-truncate"
                 i18n title="Resource">Resource
            </div>
          </th>
          <th *ngFor="let al of projectLineAList2; trackBy: trackByAllocation; let ai = index"
              scope="col">
            <div [title]="al.projectLineName"
                 class="slds-truncate"
                 style="max-width: 12rem">{{al.projectLineName}}</div>
          </th>
        </tr>
        </thead>

        <tbody [formGroup]="formGroupResource" id="resource_resource-line_b">
        <ng-container *ngFor="let r of resourceList2; trackBy: trackByRecord; let ri = index">
          <tr class="slds-hint-parent">
            <th scope="row">
              <div class="slds-truncate" style="max-width: 12rem">{{r.name}}</div>
            </th>

            <td *ngFor="let al of projectLineAList2; trackBy: trackByAllocation; let ai = index"
                [attr.data-label]="al.projectLineName"
                class="alloc-cell">
              <input [formControlName]="al.projectLineId"
                     [id]="'r2_r' + ri + '_a' + ai"
                     [title]="r.name + ' - ' + al.projectLineName"
                     [value]="r.id"
                     type="radio"/>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>

    <!--div>
      <hr/>
      <small>{{formGroupResource.value | json}}</small>
    </div-->
  </section>


  <section [class.slds-hide]="isResourceTabActive"
           [class.slds-show]="!isResourceTabActive"
           aria-labelledby="tab-allocation__item"
           class="slds-tabs_default__content"
           id="tab-allocation"
           role="tabpanel">

    <div class="slds-text-longform slds-m-bottom_small">
      For a <strong>Project</strong>, you can <em style="background: lightgreen">Share All Lines</em>.<br/>
      For a <strong>Project Line</strong>, you can <em style="background: limegreen">Share with All</em> resources.<br/>
      For a <strong>Resource</strong>, you can give <em style="background: lightblue">Access to All</em> project lines for All
      projects.
    </div>

    <!-- (3) projectLineAList \ resourceList -->
    <div *ngIf="showLinesByResource"
         class="slds-scrollable_x">
      <table [formGroup]="formGroupAllocation"
             class="slds-table slds-table_bordered"
             id="allocation_line-resource">
        <caption class="slds-assistive-text" i18n>Allocations (project line)</caption>
        <thead>
        <tr class="slds-line-height_reset">
          <th scope="col" style="vertical-align: bottom">
            <div class="slds-truncate"
                 i18n title="Project Line">Project Line
            </div>
          </th>
          <th scope="col" style="vertical-align: bottom">
            <div class="slds-truncate"
                 i18n title="Share with All Resources">Share All
            </div>
          </th>
          <ng-container *ngFor="let r of resourceList3; trackBy: trackByRecord; let ri = index">
            <th scope="col">
              <div [style.background]="background(undefined, r.id)"
                   [title]="r.label"
                   class="slds-truncate"
                   style="max-width: 12rem">{{r.label}}</div>
              <div class="slds-checkbox">
                <input [formControlName]="r.id"
                       [id]="'ra_' + ri"
                       type="checkbox"/>
                <label [for]="'ra_' + ri"
                       [title]="r.name + ' - Access to All Project Lines'"
                       class="slds-checkbox__label">
                  <span class="slds-checkbox_faux"></span>
                  <span class="slds-form-element__label slds-m-left_x-small"
                        i18n style="font-size: 0.75rem; font-weight: normal">Access All
                  </span>
                </label>
              </div>
            </th>
          </ng-container>
        </tr>
        </thead>

        <tbody id="allocation_line-resource_b">
        <tr *ngFor="let al of projectLineAList3; trackBy: trackByAllocation; let ai = index"
            class="slds-hint-parent">
          <th scope="row">
            <div class="slds-truncate" style="max-width: 12rem">{{al.projectLineName}}</div>
          </th>
          <td [style.background]="background(al.projectLineId, undefined)"
              data-label="Share All">
            <div class="slds-checkbox">
              <input [formControlName]="al.projectLineId"
                     [id]="'pa_' + ai"
                     type="checkbox"/>
              <label [for]="'pa_' + ai"
                     [title]="al.projectLineName + ' - Share with All resources'"
                     class="slds-checkbox__label">
                <span class="slds-checkbox_faux"></span>
              </label>
            </div>
          </td>

          <ng-container *ngFor="let r of resourceList3; trackBy: trackByRecord; let ri = index">
            <td [attr.data-label]="r.name"
                [style.background]="background(al.projectLineId, r.id)"
                class="alloc-cell">
              <input [formControlName]="al.projectLineId + '_' + r.id"
                     [id]="'c1_a' + ai + '_r' + ri"
                     [title]="al.projectLineName + ' - ' + r.name"
                     type="checkbox"/>
            </td>
          </ng-container>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- (4) resourceList \ projectLineAList -->
    <div *ngIf="showResourceByLines"
         class="slds-scrollable_x">
      <table [formGroup]="formGroupAllocation"
             class="slds-table slds-table_bordered"
             id="allocation_resource-line">
        <caption class="slds-assistive-text" i18n>Allocations (resource)</caption>
        <thead>
        <tr class="slds-line-height_reset">
          <th scope="col" style="vertical-align: bottom">
            <div class="slds-truncate"
                 i18n title="Resource">Resource
            </div>
          </th>
          <th scope="col" style="vertical-align: bottom">
            <div class="slds-truncate"
                 i18n title="Access to all Project Lines">Access All
            </div>
          </th>
          <th *ngFor="let al of projectLineAList4; trackBy: trackByAllocation; let ai = index"
              scope="col">
            <div [style.background]="background(al.projectLineId, undefined)"
                 [title]="al.projectLineName"
                 class="slds-truncate"
                 style="max-width: 12rem">{{al.projectLineName}}</div>
            <div class="slds-checkbox">
              <input [formControlName]="al.projectLineId"
                     [id]="'pa_' + ai"
                     type="checkbox"/>
              <label [for]="'pa_' + ai"
                     [title]="al.projectLineName + ' - Share with All resources'"
                     class="slds-checkbox__label">
                <span class="slds-checkbox_faux"></span>
                <span class="slds-form-element__label slds-m-left_x-small"
                      i18n style="font-size: 0.75rem; font-weight: normal">Share All
                </span>
              </label>
            </div>
          </th>
        </tr>
        </thead>

        <tbody id="allocation_resource-line_b">
        <ng-container *ngFor="let r of resourceList4; trackBy: trackByRecord; let ri = index">
          <tr class="slds-hint-parent">
            <th scope="row">
              <div class="slds-truncate" style="max-width: 12rem">{{r.name}}</div>
            </th>
            <td [style.background]="background(undefined, r.id)"
                data-label="Access All">
              <div class="slds-checkbox">
                <input [formControlName]="r.id"
                       [id]="'ra_' + ri"
                       type="checkbox"/>
                <label [for]="'ra_' + ri"
                       [title]="r.name + ' - Access to All project lines'"
                       class="slds-checkbox__label">
                  <span class="slds-checkbox_faux"></span>
                </label>
              </div>
            </td>

            <td *ngFor="let al of projectLineAList4; trackBy: trackByAllocation; let ai = index"
                [attr.data-label]="al.projectLineName"
                [style.background]="background(al.projectLineId, r.id)"
                class="alloc-cell">
              <input [formControlName]="al.projectLineId + '_' + r.id"
                     [id]="'c2_a' + ai + '_r' + ri"
                     [title]="r.name + ' - ' + al.projectLineName"
                     type="checkbox"/>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>

    <!-- div *ngIf="isDebug">
      <hr/>
      <small>{{formGroupAllocation.value | json}}</small>
    </div -->
  </section>

  <button (click)="onTableRotate()"
          class="slds-button slds-button_neutral slds-m-top_medium"
          id="ps-rotate">
    <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#recurring_exception"></use>
    </svg>
    <span i18n>Rotate</span>
  </button>

  <acc-spinner *ngIf="busy"></acc-spinner>
</div>


<!-- Project Selection -->
<acc-modal-float (closing)="onProjectSelected($event === true ? undefined : null)"
                 *ngIf="showProjectSelect"
                 title="Select Project">
  <acc-data-record-selector (recordSelected)="onProjectSelected($event)"
                            [columnNames]="projectSelectColumns"
                            [records]="projectRecords">
  </acc-data-record-selector>
</acc-modal-float>
